var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBulb = function SvgBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none",
    viewBox: "0 0 31 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#676879",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.385,
    d: "M13.856 26.307h3.286M22.072 15.5a6.571 6.571 0 1 0-8.214 6.339v1.875h3.285v-1.875a6.556 6.556 0 0 0 4.929-6.34M15.5 5.643V4M25.357 13.857H27M4 15.5h1.643M7.366 6.545l1.162 1.162M22.469 7.707l1.162-1.162"
  })));
};
export default SvgBulb;